import { Button } from 'material-ui';
import { showMessage } from 'modules/messages/actions';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateBadFitItem } from 'service/api';
import { failedMessage } from 'service/constants';
import { faSpinner } from '@fortawesome/fontawesome-free-solid'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import './table-buttons.scss'
import { deleteBadFitItem } from 'modules/admin/redux/actions';

const TableButtons = ({badFitId}) => {
    const dispatch = useDispatch()
    const [goodFitLoad, setLoading] = useState(false)
    const [deleting, setDeleting] = useState(false)

    const goodFitHandler = async () => await requestHandler(setLoading, {goodForMonth: true})

    const deleteHandler = async () => await requestHandler(setDeleting, {isGoodFeet: true})
    

    const requestHandler = async (setState, params) => {
        try {
            setState(true) 
            await updateBadFitItem(badFitId, params)
            dispatch(deleteBadFitItem(badFitId))
        } catch {
            dispatch(showMessage(failedMessage))
        } finally {
            setState(false)
        }
    }

    return (
        <div className='table-buttons'>
            <Button 
                color="primary" 
                variant="raised" 
                className="good-fit-btn"
                onClick={goodFitHandler}
                disabled={goodFitLoad}
            >
                {
                    goodFitLoad 
                        ? <FontAwesomeIcon icon={faSpinner} spin />
                        : "good fit"
                }      
            </Button>
            <Button 
                color="secondary" 
                variant="raised" 
                onClick={deleteHandler}
                disabled={deleting}
            >
                {
                    deleting 
                        ? <FontAwesomeIcon icon={faSpinner} spin />
                        : "delete"
                }       
            </Button>
        </div>
    );
};

export default TableButtons;